import { Pressable, Text, View } from 'react-native';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useEffect, useState } from 'react';
import { TwColumn, TwInput, TwPage, TwPageHeader } from '@tw/tw-components-rn';

import { BfAppContext } from '@tw/tw-runtime';
import { Icon } from 'native-base';
import { MaterialIcons } from '@expo/vector-icons';
import { ScrollView } from 'react-native-gesture-handler';
import { TwButton } from '@/app/components/tw-button/TwButton';
import { styles } from './styles';

export const AuthChangePassword = () => {
  const [oldPwd, setOldPwd] = useState('');
  const [pwd, setPwd] = useState('');
  const [pwdConfirm, setPwdConfirm] = useState('');

  const [showOldPwd, setShowOldPwd] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [showPwdConfirm, setShowPwdConfirm] = useState(false);

  const [changePwdOk, setChangePwdOk] = useState(false);

  useEffect(() => {
    if (oldPwd !== '' && pwd !== '' && pwd === pwdConfirm && pwd.length >= 6) {
      setChangePwdOk(true);
    } else {
      setChangePwdOk(false);
    }
  }, [oldPwd, pwd, pwdConfirm]);

  return (
    <TwPage translucentStatusBar={true}>
      <TwPage.Header title={'修改密码'}></TwPage.Header>
      <ScrollView style={styles.container}>
        <TwColumn style={styles.loginContainer} space={4} testID="Login_form">
          <TwColumn testID="Change_password_old_password" space={1}>
            <Text style={styles.title}>原密码</Text>
            <TwInput
              style={styles.input}
              value={oldPwd}
              type={showOldPwd ? 'text' : 'password'}
              size={'md'}
              placeholder="请输入原密码"
              onChangeText={(text) => {
                setOldPwd(text);
              }}
              InputRightElement={
                <Pressable onPress={() => setShowOldPwd(!showOldPwd)}>
                  <Icon
                    as={<MaterialIcons name={showOldPwd ? 'visibility' : 'visibility-off'} />}
                    size={5}
                    mr="2"
                    color="muted.400"
                  />
                </Pressable>
              }
            />
          </TwColumn>
          <TwColumn testID="Change_password_new_password" space={1}>
            <Text style={styles.title}>新密码</Text>
            <TwInput
              style={styles.input}
              value={pwd}
              type={showPwd ? 'text' : 'password'}
              size={'md'}
              placeholder="请输入最少长度为6的新密码"
              onChangeText={(text) => {
                setPwd(text);
              }}
              InputRightElement={
                <Pressable onPress={() => setShowPwd(!showPwd)}>
                  <Icon
                    as={<MaterialIcons name={showPwd ? 'visibility' : 'visibility-off'} />}
                    size={5}
                    mr="2"
                    color="muted.400"
                  />
                </Pressable>
              }
            />
          </TwColumn>
          <TwColumn testID="Change_password_confirm_password" space={1}>
            <Text style={styles.title}>确认新密码</Text>
            <TwInput
              style={styles.input}
              value={pwdConfirm}
              type={showPwdConfirm ? 'text' : 'password'}
              size={'md'}
              placeholder="请确认最少长度为6的新密码"
              onChangeText={(text) => {
                setPwdConfirm(text);
              }}
              InputRightElement={
                <Pressable onPress={() => setShowPwdConfirm(!showPwdConfirm)}>
                  <Icon
                    as={<MaterialIcons name={showPwdConfirm ? 'visibility' : 'visibility-off'} />}
                    size={5}
                    mr="2"
                    color="muted.400"
                  />
                </Pressable>
              }
            />
          </TwColumn>
          <TwButton
            style={styles.submit}
            isDisabled={!changePwdOk}
            onPress={async () => {
              try {
                await BfAppContext.getInstance().getUserService().requestChangePwd({ oldPwd: oldPwd, newPwd: pwd });
                BfAppContext.getInstance().getMessageService().showSuccess('密码修改成功');
                BfAppContext.getInstance().getRouteService().back();
              } catch (error) {
                console.log(error);
              }
            }}
          >
            修改
          </TwButton>
        </TwColumn>
      </ScrollView>
    </TwPage>
  );
};
